import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";
import { Table } from "semantic-ui-react";
import {
  selectImagesList,
  selectSizesList
} from "../../../state/reducers/projectWizard/projectWizardSelectors.js";

import { padNumber } from "../../../utils/numberUtils.js";

class ResourcePanelSummary extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    resourceType: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    copyKey: PropTypes.string.isRequired,

    imagesList: PropTypes.array.isRequired,
    sizesList: PropTypes.array.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.resource_panel"
  };

  // -- RENDER -- //

  getDataVolumeUnits = resource => {
    const { copyKey, copy } = this.props;

    let units = copy(`${copyKey}.volumes.data.units`);

    if (resource.dataVolumeCount > 1) {
      units = `${units} x${resource.dataVolumeCount}`;
    }

    return units;
  };

  renderResourceRow = (resource, key) => {
    const { imagesList, sizesList, copyKey, copy } = this.props;

    const size = sizesList.find(item => item.value === resource.size);
    const image = imagesList.find(item => item.value === resource.image);

    const startAt = resource.startAt ?? 1;

    const startingNumber = resource.useZeroPadding
      ? padNumber(startAt, 4)
      : startAt;

    const name = resource.namingScheme
      ? `${resource.namingScheme.replace(
          "{number}",
          `{number, starts at ${startingNumber}}`
        )}`
      : resource.name;

    return (
      <Table.Row key={key}>
        <Table.Cell collapsing>{resource.number || 1}x</Table.Cell>
        <Table.Cell collapsing>{name}</Table.Cell>
        <Table.Cell collapsing>{image.text}</Table.Cell>
        <Table.Cell colSpan={resource.dataVolumeSize ? 1 : 2}>
          {size.text}
        </Table.Cell>
        {resource.dataVolumeSize && (
          <Table.Cell collapsing>
            {resource.dataVolumeSize}
            {this.getDataVolumeUnits(resource)}
            <br />
            <span className="mini-text">
              {copy(`${copyKey}.volumes.data.short_label`)}
            </span>
          </Table.Cell>
        )}
        {resource.rootVolumeSize && (
          <Table.Cell collapsing>
            {resource.rootVolumeSize}
            {copy(`${copyKey}.volumes.root.units`)}
            <br />
            <span className="mini-text">
              {copy(`${copyKey}.volumes.root.short_label`)}
            </span>
          </Table.Cell>
        )}
      </Table.Row>
    );
  };

  renderActive(resources) {
    const { copyKey, copy } = this.props;

    return (
      <Table celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan="6">
              {copy(`${copyKey}.title`)}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {resources.map((resource, index) => {
            return this.renderResourceRow(resource, `resource-${index}`);
          })}
        </Table.Body>
      </Table>
    );
  }

  renderInactive() {
    return null;
  }

  render() {
    const {
      id,
      formikProps: { values }
    } = this.props;

    const resources = values[id] || [];

    if (resources.length > 0) {
      return this.renderActive(resources);
    }

    return this.renderInactive();
  }
}

const mapStateToProps = (state, props) => ({
  imagesList: selectImagesList(state, props),
  sizesList: selectSizesList(state, props),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ResourcePanelSummary);
